export default "__VITE_ASSET__DIxdgKcu__"